import { defineMessages } from 'react-intl';

export default defineMessages({
  contentTabLabel: {
    id: 'General.contentLabel',
    defaultMessage: 'Content',
  },
  hideLabel: {
    id: 'General.hideLabel',
    defaultMessage: 'Hide',
  },
  readMoreLabel: {
    id: 'General.readMoreLabel',
    defaultMessage: 'Read more',
  },
  continueToBtnLabel: {
    id: 'CourseDetailsHeader.continueToBtnLabel',
    defaultMessage: 'Continue to {lessonName}',
    description:
      'Button label displayed in courses details header on continue to next lesson button',
  },
  startBtnLabel: {
    id: 'CourseDetailsHeader.startBtnLabel',
    defaultMessage: 'Start course',
    description:
      'Button label displayed in courses details header if no lesson is completed yet',
  },
  giveCourseFedbackLabel: {
    id: 'CourseDetailsHeader.giveCourseFedbackLabel',
    defaultMessage: 'Give feedback regarding this course',
    description:
      'Give feedback regarding this course button label displayed in courses details header',
  },
  discussionTabLabel: {
    id: 'CourseDetailsHeader.discussionTabLabel',
    defaultMessage: 'Discussions',
    description: 'Discussion tab label displayed in courses details header',
  },
  discussionTabLabelWithCount: {
    id: 'CourseDetailsHeader.discussionTabLabelWithCount',
    defaultMessage: 'Discussions ({count})',
    description: 'Discussion tab label displayed in courses details header',
  },
  notesTabLabel: {
    id: 'CourseDetailsHeader.notesTabLabel',
    defaultMessage: 'Notes',
    description: 'Notes tab label displayed in courses details header',
  },
  notesTabLabelWithCount: {
    id: 'CourseDetailsHeader.notesTabLabelWithCount',
    defaultMessage: 'Notes ({count})',
    description: 'Notes tab label displayed in courses details header',
  },
  recommendedStudyTime: {
    id: 'CourseDetailsHeader.recommendedStudyTime',
    defaultMessage: 'Recommended study time:',
    description: 'Study hours displayed in courses details header',
  },
  mediaDurations: {
    id: 'CourseDetailsHeader.mediaDurations',
    defaultMessage: 'Media durations:',
    description: 'Study hours displayed in courses details header',
  },
  studyTimeHours: {
    id: 'CourseDetailsHeader.studyTimeHours',
    defaultMessage: '{time} {time, plural, one {hour} other {hours}}',
    description: 'Study hours displayed in courses details header',
  },
  studyTimeMinutes: {
    id: 'CourseDetailsHeader.studyTimeMinutes',
    defaultMessage: '{time} minutes',
    description: 'Study minutes displayed in courses details header',
  },
  autoHideDate: {
    id: 'CourseDetailsHeader.autoHideDate',
    defaultMessage: 'The removal date: {date}',
  },
  addToBtnLabel: {
    id: 'CourseDetailsHeader.addToFavoritesBtnLabel',
    defaultMessage: 'Add to favourites',
    description:
      'Add to favourites button label displayed in courses details header',
  },
  removeFromBtnLabel: {
    id: 'CourseDetailsHeader.removeFromFavoritesBtnLabel',
    defaultMessage: 'Remove from favourites',
    description:
      'Remove from favourites button label displayed in courses details header',
  },
  editCourseBtnLabel: {
    id: 'CourseDetailsContent.editCourseBtnLabel',
    defaultMessage: 'Edit',
    description: 'Edit displayed in course details on button Edit course',
  },
  removeLabel: {
    id: 'CourseDetailsContent.removeLabel',
    defaultMessage: 'Remove',
    description: 'Message displayed for editors and admin',
  },
  submitDeleteItemMsg: {
    id: 'CourseDetailsContent.submitDeleteItemMsg',
    defaultMessage: 'Are you sure you want to delete {name}?',
  },
  itemWillBeRemovedMsg: {
    id: 'CourseDetailsContent.itemWillBeRemovedMsg',
    defaultMessage: 'Course <b>{name}</b> will be removed.',
  },
  itemRemoved: {
    id: 'CourseDetailsContent.itemRemoved',
    defaultMessage: 'Course <b>{name}</b> has been removed',
  },
  addForOffline: {
    id: 'CourseDetailsHeader.addForOffline',
    defaultMessage: 'Download for offline',
  },
  removeForOffline: {
    id: 'CourseDetailsHeader.removeForOffline',
    defaultMessage: 'Remove from offline',
  },
  courseIsDownloading: {
    id: 'CourseItem.courseIsDownloading',
    defaultMessage: 'Downloading course "{name}", related lessons and notes...',
  },
  courseIsDownloaded: {
    id: 'CourseItem.courseIsDownloaded',
    defaultMessage: '"{name}" offline access download complete',
  },
  courseIsRemovedFromOffline: {
    id: 'CourseItem.courseIsRemovedFromOffline',
    defaultMessage:
      'Course "{name}", related lessons and notes are removed from offline access',
  },
  browserDoesNotSupportCaching: {
    id: 'CourseItem.browserDoesNotSupportCaching',
    defaultMessage:
      'Your browser does not support offline caching. For better browsing experience, we recommend using Skhole with Google Chrome',
  },
  errorDuringCourseDownloading: {
    id: 'CourseItem.errorDuringCourseDownloading',
    defaultMessage: 'Oops, error happened during updating cache: {error}',
  },
  courseIsDownloadingWarning: {
    id: 'CourseItem.courseIsDownloadingWarning',
    defaultMessage:
      'Course "{name}" is still downloading for offline, are you sure you want to exit?',
  },
  availableForOfflineTime: {
    id: 'CourseItem.availableForOfflineTime',
    defaultMessage: '{days} days remaining in offline mode',
  },
  downloadButtonTourDescription: {
    id: 'CourseDetailsHeader.downloadButtonTourDescription',
    defaultMessage:
      '{serviceNamePossessive} courses can also be viewed without internet connection.<br />Click here to download course for offline use<br /><a href="https://support.skhole.fi/en/articles/3266385-downloading-courses-offline" target="_blank">Learn more about this functionality</a>',
  },
  showCertificateBtnLabel: {
    id: 'CourseDetailsHeader.showCertificateBtnLabel',
    defaultMessage: 'Show certificate',
  },
  resetCourseProgress: {
    id: 'CourseDetailsHeader.resetCourseProgress',
    defaultMessage: 'Restart course',
  },
  resetCourseTitle: {
    id: 'CourseDetailsHeader.resetCourseTitle',
    defaultMessage: 'Do you want to reset course progress status?',
  },
  courseProgressResetSnackbar: {
    id: 'CourseDetailsHeader.courseProgressResetSnackbar',
    defaultMessage: '{name} progress has been reset',
  },
  courseProgressResetDescription: {
    id: 'CourseDetailsHeader.courseProgressResetDescription',
    defaultMessage:
      '<div><p>Choosing yes will reset completion status of lessons in course. You cannot undo it. If you just want to see lessons again choose No.</p><p>Note, resetting course status will not  affect old statistics and old certificates. You may want to reset course status if your {teacher} wants you to re-study the course.</p></div>',
  },
  teacher: {
    id: 'General.teacher',
    defaultMessage: 'teacher',
  },
  teacherProfessional: {
    id: 'General.teacherProfessional',
    defaultMessage: 'teacher',
  },
  deleteBtn: {
    id: 'CourseDetailsHeader.deleteBtn',
    defaultMessage: 'Remove course',
  },
  copyBtn: {
    id: 'CourseDetailsHeader.copyBtn',
    defaultMessage: 'Copy course',
  },
  copyConfirmationTitle: {
    id: 'CourseDetailsHeader.copyConfirmationTitle',
    defaultMessage: 'Are you sure to copy this course?',
  },
  copyConfirmationSubmitLabel: {
    id: 'CourseDetailsHeader.copyConfirmationSubmitLabel',
    defaultMessage: 'Copy',
  },
  editCourse: {
    id: 'CourseDetailsHeader.editCourse',
    defaultMessage: 'Edit course',
  },
  pwaIsAboutToBeDisabled: {
    id: 'General.pwaIsAboutToBeDisabled',
    defaultMessage:
      'Removing this course from offline cache temporarily disables offline mode. All pages will reload',
  },
  confirm: {
    id: 'General.confirmDisablePwa',
    defaultMessage: 'Confirm',
  },
  dismiss: {
    id: 'General.dismissDisablePwa',
    defaultMessage: 'Dismiss',
  },
  serviceNamePossessive: {
    id: 'General.defaultServiceNamePossessive',
    defaultMessage: "Skhole's",
  },
  viewLivestreamChat: {
    id: 'CourseDetailsHeader.viewLivestreamChat',
    defaultMessage: 'View Stream Chat',
  },
  hideLivestreamChat: {
    id: 'CourseDetailsHeader.hideLivestreamChat',
    defaultMessage: 'Hide Stream Chat',
  },
  streaming: {
    id: 'CourseDetailsHeader.streaming',
    defaultMessage: 'Livestream',
  },
  streamingStartAt: {
    id: 'CourseDetailsHeader.streamingStartAt',
    defaultMessage: '{start} - {end}',
  },
  progressBarLabel: {
    id: 'CourseDetailsHeader.progressBarLabel',
    defaultMessage: 'Progress',
  },
});
